import { mix, observable, passthruLayout } from "@chorda/core";
import "bulma-slider/dist/css/bulma-slider.min.css";
export const Slider = (props) => {
    return mix({
        layout: passthruLayout,
        templates: {
            input: {
                tag: 'input',
                css: 'slider',
                dom: {
                    type: 'range'
                },
                reactions: {
                    value: v => ({ dom: { value: v } }),
                    min: v => ({ dom: { min: v } }),
                    max: v => ({ dom: { max: v } }),
                    name: v => ({ dom: { id: v } }),
                },
                events: {
                    $dom: {
                        change: (e, { value }) => {
                            value.$value = e.currentTarget.valueAsNumber;
                        }
                    }
                },
            },
            output: {
                tag: 'output',
                reactions: {
                    name: v => ({ dom: { htmlFor: v } }),
                    value: v => ({ text: String(v) })
                }
            }
        }
    }, props === null || props === void 0 ? void 0 : props.as, props && {
        templates: {
            input: {
                classes: {
                    'has-output': true
                }
            }
        },
        defaults: {
            value: () => observable(props.value),
            min: () => observable(props.min),
            max: () => observable(props.max),
            name: () => props.name
        },
        injections: {
            value: props.value$,
            max: props.max$,
            min: props.min$,
        }
    });
};
